<template>
  <v-container>
    <!-- Hero Section -->
    <h1 class="devcentre-intro text-center mb-6">
      Enterprise Software Solutions & Integration
    </h1>
    <p class="devcentre-subintro text-center mx-auto" style="max-width: 800px">
      We build custom software solutions that bring people and systems together.
      Our development expertise in AI, automation, integration, and
      visualization helps organizations innovate - turning complex business
      requirements into powerful, scalable applications.
    </p>

    <div class="text-center my-6">
      <v-btn
        color="primary"
        dark
        x-large
        to="/assistant"
        class="devcentre-button"
      >
        Talk to AI Solution Assistant
      </v-btn>
    </div>

    <!-- Feature Sections -->

    <v-row
      v-for="(feature, index) in features"
      :key="index"
      align="center"
      class="feature-section my-12"
    >
      <v-col cols="12" md="6">
        <v-img
          :src="feature.image"
          :alt="feature.alt"
          class="rounded-lg elevation-3"
        />
      </v-col>
      <v-col cols="12" md="6" class="feature-content">
        <h2 class="text-h4 mb-4 primary--text">{{ feature.title }}</h2>
        <p class="devcentre-subintro">
          {{ feature.description }}
        </p>
        <div class="mt-4">
          <v-chip
            v-for="tag in feature.tags"
            :key="tag"
            class="mr-2 mb-2"
            color="primary"
            outlined
          >
            {{ tag }}
          </v-chip>
        </div>
      </v-col>
    </v-row>

    <!-- Call to Action Section -->
    <v-row align="center" justify="center" class="mt-16 mb-8">
      <v-col cols="12" sm="6" class="text-center">
        <v-btn
          color="primary"
          dark
          x-large
          to="/assistant"
          class="mb-4 mb-sm-0 mx-2"
          block
        >
          Talk to AI Solution Assistant
        </v-btn>
      </v-col>
      <v-col cols="12" sm="6" class="text-center">
        <v-btn color="secondary" dark x-large to="/contact" class="mx-2" block>
          Request Human Help
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "HomeView",
  components: {},
  data: () => ({
    features: [
      {
        title: "Expert Software Solutions",
        description:
          "Our experienced experts can tackle your unique business needs with our adaptable suite of technologies.",
        image: "/images/user_and_professional.jpg",
        alt: "Expert Software Solutions",
        tags: [
          "Custom Development",
          "Enterprise Solutions",
          "Expert Consultation",
        ],
      },
      {
        title: "Automation Excellence",
        description:
          "Enhance efficiency, reduce errors, and save time with our cutting-edge automation services.",
        image: "/images/real_world_site.jpg",
        alt: "Automation Excellence",
        tags: [
          "Process Automation",
          "Workflow Optimization",
          "Business Rule Enforcement",
        ],
      },
      {
        title: "Seamless Integration",
        description:
          "Integrate your platforms effortlessly, ensuring data flows smoothly across your organization.",
        image: "/images/integration.jpg",
        alt: "Seamless Integration",
        tags: [
          "API Integration",
          "Data Synchronization",
          "System Connectivity",
        ],
      },
      {
        title: "Visualize Success",
        description:
          "Our visualization expertise makes complex information understandable and decision-making clearer.",
        image: "/images/visualization.jpg",
        alt: "Visualize Success",
        tags: [
          "Data Visualization",
          "Interactive Dashboards",
          "Business Intelligence",
        ],
      },
      // Add other features similarly...
    ],
  }),
};
</script>

<style scoped>
.feature-section {
  position: relative;
  transition: all 0.3s ease;
}

.feature-section:hover {
  transform: translateY(-5px);
}

.feature-content {
  padding: 2rem;
}

.devcentre-intro {
  font-size: 3.5rem;
  font-weight: 700;
  line-height: 1.2;
  background: linear-gradient(45deg, #2ab3b8, #1e7b80);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.devcentre-subintro {
  font-size: 1.2rem;
  line-height: 1.6;
  color: #37474f;
}

/* Add some animation classes */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
